import { Navigate, Route, Routes } from 'react-router';

import {
  BillingDetailPage,
  BillingInvoicePage,
  BillingMainPage,
  BillingRequestPage,
  BillingSuccessPage
} from '#pages';

import { Container } from './styles';
import Billing from 'src/r_page/billing';
import CoachSettlements from '#providers/CoachSettlements';
import CoachSettlementsInfo from '#providers/CoachSettlementsInfo';

export function BillingView() {
  return (
    <>
      <Container>
        <Routes>
          <Route path="" element={<Navigate replace to="registration/rrn" />} />
          <Route
            path="registration/*"
            element={
              <Routes>
                {/* <Route path="" element={<BillingRegistrationPage />} /> */}
                {/* <Route path="rrn" element={<BillingRegRRNPage />} /> */}
                {/* <Route path="account" element={<BillingRegAccountPage />} /> */}
                <Route path="" element={<Billing />} />
              </Routes>
            }
          />
        </Routes>
        <CoachSettlements>
          <CoachSettlementsInfo>
            <Routes>
              <Route path="" element={<BillingMainPage />} />
              <Route path="detail" element={<BillingDetailPage />} />
              <Route
                path="request/*"
                element={
                  <Routes>
                    <Route path="" element={<BillingRequestPage />} />
                    <Route path="invoice" element={<BillingInvoicePage />} />
                    <Route path="success" element={<BillingSuccessPage />} />
                  </Routes>
                }
              />
            </Routes>
          </CoachSettlementsInfo>
        </CoachSettlements>
      </Container>
    </>
  );
}
